import Arrow from './Arrow';
import { C } from './theme';
import KpiTooltip from './KpiTooltip';

const shimmerStyle: React.CSSProperties = {
    width: 50,
    height: 10,
    borderRadius: 3,
    background: 'linear-gradient(90deg, #e8eaf0 25%, #f3f4f8 37%, #e8eaf0 63%)',
    backgroundSize: '800px 100%',
    animation: 'shimmer 1.4s ease infinite',
    margin: '3px auto 0',
};

const KPI = ({
    label, value, delta, up, drill, onClick, deltaLoading, tooltip, isMobile, subtext, subtextLoading, cancelledOrdersArrow,
}: {
    label: string;
    value: any;
    delta?: string | null;
    up?: boolean;
    drill?: boolean;
    onClick?: () => void;
    deltaLoading?: boolean;
    tooltip?: string;
    isMobile?: boolean;
    subtext?: string | null;
    subtextLoading?: boolean;
    // For "lower is better" metrics (Cancelled, Refund, etc.): when true, the arrow reflects the
    // actual sign of `delta` instead of `up` (which callers invert so it only drives color).
    cancelledOrdersArrow?: boolean;
}) => {
    // subtext and delta are independent rows (a card can show both at once, e.g. "net of $X
    // refunded" above the delta) — neither one hides the other, matching how the desktop
    // stamp KPI tiles already render both lines side by side.
    let subtextRow: React.ReactNode = null;
    if (subtextLoading) {
        subtextRow = <div style={shimmerStyle} />;
    } else if (subtext) {
        subtextRow = <div style={{ fontSize: 9, fontWeight: 500, color: C.t3, marginTop: 3 }}>{subtext}</div>;
    }

    let deltaRow: React.ReactNode = null;
    if (deltaLoading) {
        deltaRow = <div style={shimmerStyle} />;
    } else if (delta) {
        const isZero = parseFloat(delta) === 0;
        const showUpArrow = cancelledOrdersArrow ? parseFloat(delta) >= 0 : up;
        deltaRow = (
            <div style={{ fontSize: 9, fontWeight: 600, color: isZero ? C.t2 : up ? C.green : C.red, marginTop: 3 }}>
                {isZero ? delta.replace(/^[+-]/, '') : `${showUpArrow ? '↑' : '↓'} ${delta}`}
            </div>
        );
    }

    return (
        <div
            onClick={onClick}
            style={{
                background: C.card,
                border: `1px solid ${drill ? C.accent + '33' : C.cardBorder}`,
                borderRadius: 12,
                padding: '12px 10px',
                textAlign: 'center',
                cursor: drill ? 'pointer' : 'default',
                position: 'relative',
                boxShadow: C.shadow,
            }}
        >
            {drill && <Arrow />}
            <div style={{ fontSize: 8, color: C.t3, textTransform: 'uppercase', letterSpacing: 0.3, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
                {label}
                {tooltip && <KpiTooltip text={tooltip} isMobile={isMobile} />}
            </div>
            <div style={{ fontSize: 18, fontWeight: 700, color: C.t1, marginTop: 4, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{value}</div>
            {subtextRow}
            {deltaRow}
        </div>
    );
};

export default KPI;

